import { createSlice } from "@reduxjs/toolkit";
import { getListTelcoDataGift } from "../../api/giftExchange/dataGift";

const initialState = {
  listTelcoDataGifts: [],
  isLoadTelcoDataGift: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0,
};

const telcoDataGiftSlice = createSlice({
  name: "telcoDataGift",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListTelcoDataGift.pending, (state) => {
        state.isLoadTelcoDataGift = true;
        state.error = null;
      })
      .addCase(getListTelcoDataGift.fulfilled, (state, action) => {
        state.isLoadTelcoDataGift = false;
        state.listTelcoDataGifts = action.payload.data || [];
        state.currentPage = action.payload.current_page;
        state.pageSize = action.payload.per_page;
        state.totalRecords = action.payload.total;
      })
      .addCase(getListTelcoDataGift.rejected, (state, action) => {
        state.isLoadTelcoDataGift = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = telcoDataGiftSlice.actions;
export default telcoDataGiftSlice.reducer;
